import React, { ReactChild, ReactFragment, ReactPortal } from "react";
//
import { Container, Content } from "./style";
//Component
import Header from "@components/Header";
import JumBotron from "@components/JumBotron";
import SearchCase from "@components/SearchCase";
interface ILayoutProps {
  children?:
    | ReactChild
    | ReactFragment
    | ReactPortal
    | boolean
    | null
    | undefined;
}
const Layout = ({ children }: ILayoutProps) => (
  <Container>
    <Header />
    <JumBotron />
    <Content>{children}</Content>
  </Container>
);

export default Layout;
